export default __webpack_public_path__ + "static/media/leafLeft.46c72c91.png";